import Component from '../core/Component';
import throttle from 'lodash/throttle';
import Scroll from '../services/Scroll';
import EventBus from '../core/EventBus';
import Ajax from '../core/Ajax';

const STATES = {
    PINNED:  'is-pinned',
    ACTIVE:  'is-active',
    VISIBLE: 'is-visible',
};

const logo = document.querySelector('.Header-logo img');

export default class Header extends Component {
    constructor(element) {
        super(element);

        this.isPinned = false;
        this.isVisible = false;
        this.currentOffset = window.scrollY;
        this.inverted = this.element.classList.contains('Header--inverted') ? true : false;

		this.ref = {
			headerMessage: null,
			headerMessageClose: null
		};
    }

    prepare() {
        Scroll.on('scroll', this.handleScroll);
        if (this.inverted && this.currentOffset > 0) this.invertLogo(true);

        setTimeout(() => {
            this.handleScroll({
                offset: {
                    x: 0,
                    y: document.body.scrollTop || document.documentElement.scrollTop
                }
            });
        }, 300);

		if (this.ref.headerMessageClose) {
			this.ref.headerMessageClose.addEventListener('click', ::this.hideMessage);
		}
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll);
    }

    handleScroll = ({offset}) => {
        offset = offset.y;
        if (offset > 0) {
            if (!this.isPinned) {
                this.pin();
            }
        } else if (offset < 5) {
            if (this.isPinned) {
                this.unpin();
            }
        }

        if (offset > 100) {
            if (!this.isVisible) {
                this.show();
            }
        }

        if (offset < 99) {
            if (this.isVisible) {
                this.hide();
            }
        }

        this.currentOffset = offset;
    };

    active() {
        this.isActive = true;
        this.element.classList.add(STATES.ACTIVE);
    }

    unactive() {
        this.isActive = false;
        this.element.classList.remove(STATES.ACTIVE);
    }

    pin() {
        this.isPinned = true;
        this.element.classList.add(STATES.PINNED);
        this.element.offsetWidth;
        this.emit('pin:change', {
            pinned: true,
        });
        if (this.inverted) {
            this.invertLogo(true);
        }
    }

    unpin() {
        this.isPinned = false;
        this.isVisible = false;
        this.element.classList.remove(STATES.PINNED);
        this.element.classList.remove(STATES.VISIBLE);
        this.emit('pin:change', {
            pinned: false,
        });

        if (this.inverted && window.pageYOffset === 0 && !document.documentElement.classList.contains('is-scrolling-disabled')) {
            this.invertLogo(false);
        }
    }

    show() {
        this.isVisible = true;
        this.element.classList.add(STATES.VISIBLE);
        this.emit('show');
    }

    hide() {
        this.isVisible = false;
        this.element.classList.remove(STATES.VISIBLE);
        this.emit('hide');
    }

    getHeight() {
        const box = this.element.getBoundingClientRect();

        return box.top + box.height;
    }

    invertLogo(state) {
        state ? (logo.src = '/assets/img/logo-foxentry.svg') : (logo.src = '/assets/img/logo-foxentry-inverted.svg');
    }

	hideMessage() {
		const headerClass = 'header--has-message';
		const url = this.ref.headerMessageClose.dataset.url;

		const ajax = new Ajax();
		ajax.get(url, null, (response) => {});

		this.element.classList.remove(headerClass);
		this.ref.headerMessage.remove();
	}
}
